import Typography from "@mui/material/Typography";
import { Unit } from "../../@data/unit";
import { Phone, Room } from "@mui/icons-material";
import { Button, Grow } from "@mui/material";
import * as s from "./styles";

interface IUnitCard {
  unit: Unit;
  handleOpenUnit: (unit: Unit) => void;
}

export default function UnitCard(props: IUnitCard) {
  const { unit, handleOpenUnit } = props;

  return (
    <Grow in timeout={800}>
      <s.CardContainer onClick={() => handleOpenUnit(unit)}>
        <section>
          <Typography gutterBottom variant="body1">
            {unit.name}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "flex" }}
          >
            <Room sx={{ fontSize: "0.8rem", margin: "0.25rem 0.25rem 0 0" }} />
            {unit.address}
          </Typography>
          {unit?.phone && (
            <Button
              variant="contained"
              startIcon={<Phone />}
              size="small"
              sx={{ mt: "1rem" }}
              href={`tel:${unit?.phone}`}
            >
              Entrar em contato
            </Button>
          )}
        </section>
        {unit.imageUrl && (
          <img src={unit.imageUrl} alt={`Imagem da ${unit.name}`} />
        )}
      </s.CardContainer>
    </Grow>
  );
}
